import 'swiper/swiper.min.css';
import './assets/boxicons-2.0.7/css/boxicons.min.css';
import './App.scss';

import { BrowserRouter, Route } from 'react-router-dom';

import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import LoginPage from './components/login-page/LoginPage';
import React,{useState} from 'react';

import Routes from './config/Routes';

function App() {
    let initialValue = localStorage.getItem('set') ? localStorage.getItem('set') : 'false';
    const [login, setLogin] = useState(initialValue);
    
    return (
        <>
        {
          login==='true' ?
        <BrowserRouter>
          <Route render={props => (        <>
              <Header {...props} />
              <Routes />
              <Footer setLogin={setLogin}/>
            </>
          )} />
        </BrowserRouter>

        :<LoginPage setLogin={setLogin}/>
        }
        </>
    );
}

export default App;
